module.exports = __webpack_public_path__ + "static/media/Saint-Laurent-Black-Niki-Swarovski-Crystal-embellished-Leather-Knee-Boots-Lyst_thumb.335242a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/shoes/Saint-Laurent-Black-Niki-Swarovski-Crystal-embellished-Leather-Knee-Boots-Lyst_thumb.png
// module id = 288
// module chunks = 0